import React from 'react';
import PropTypes from 'prop-types';
import { toAccountPropType, fromAccountPropType } from '../../states/accounts/propTypes';
import AccountCard from '../AccountCard';

export const AccountSelector = ({ title, accounts, selectedAccountId, onAccountSelect }) => (
	<div className="c-m-payment-account-selector" data-cy="payment-account-selector">
		<h3 className="c-m-payment-account-selector__title">{title}</h3>
		{accounts.map((account) => (
			<AccountCard
				key={account.id}
				id={account.id}
				number={account.number}
				type={account.type}
				sortCode={account.sortCode}
				accountNumber={account.accountNumber}
				name={account.displayName}
				currentBalance={account.currentBalance}
				availableBalance={account.availableBalance}
				onClick={onAccountSelect}
				isSelected={selectedAccountId === account.id}
				accountHolder={account.accountHolder}
			/>
		))}
	</div>
);

AccountSelector.propTypes = {
	title: PropTypes.string.isRequired,
	selectedAccountId: PropTypes.string,
	accounts: PropTypes.arrayOf(
		PropTypes.oneOfType([PropTypes.shape(fromAccountPropType), PropTypes.shape(toAccountPropType)])
	).isRequired,
	onAccountSelect: PropTypes.func.isRequired,
};
export default AccountSelector;
